import { useCallback } from 'react';
import { TranslationTeam } from '@deaf-bible-society-2-0/deafbible-metadata-utils';

import useInternationalization from '../../hooks/useInternationalization';
import styles from './styles.module.css';

interface Props {
  team: TranslationTeam | undefined;
  qualityChecks: string[];
  darkMode: boolean;
  isMobile: boolean;
}

/**
 * Format quality-check labels for display.
 */
const qualityCheckText = (checks: string[]): string =>
  checks.length === 2 ? `${checks[0]} & ${checks[1]}` : checks[0];

/**
 * Translation team logo, copyright, and quality text for the selected watch plan video.
 */
const WatchPlanVideoTeamBar = ({
  team,
  qualityChecks,
  darkMode,
  isMobile,
}: Props): JSX.Element | null => {
  const { getIntlText } = useInternationalization();

  const imgUrl = darkMode && team?.logo_darkmode_url ? team.logo_darkmode_url : team?.logo_url;

  const isWebsite =
    team?.website_url !== undefined &&
    team.website_url !== null &&
    team.website_url.toString().length > 0;

  const openTeamWebsite = useCallback((): void => {
    if (isWebsite && team?.website_url) {
      window.open(team.website_url);
    }
  }, [isWebsite, team]);

  if (team === undefined) {
    return null;
  }

  return (
    <div
      className={`${styles.teamBar} ${darkMode && styles.teamBarDarkMode} ${
        isMobile && styles.teamBarMobile
      }`}
    >
      {imgUrl && (
        <div className={styles.teamLogoContainer}>
          <img src={imgUrl} alt="" className={styles.teamLogo} crossOrigin="anonymous" />
        </div>
      )}
      {team.copyright && (
        <button
          type="button"
          className={`${styles.teamCopyright} ${isWebsite && styles.teamCopyrightLink}`}
          onClick={openTeamWebsite}
          disabled={!isWebsite}
        >
          {`${getIntlText('translated_by')}: ${team.copyright}`}
        </button>
      )}
      {qualityChecks.length > 0 && (
        <span className={styles.teamQuality}>{` | Quality-checked by ${qualityCheckText(
          qualityChecks
        )}`}</span>
      )}
    </div>
  );
};

export default WatchPlanVideoTeamBar;
